import { formatDate } from '@core/utils/filter'

export const STATUS_PENDING = 'pending'
export const STATUS_DONE = 'done'

export const statusLabels = {
  pending: 'Pending',
  done: 'Done',
  failed: 'Failed',
}

export const statusVariants = {
  pending: 'warning',
  done: 'success',
  failed: 'danger',
}

export const restoreStatusLabels = {
  pending: 'Pending',
  running: 'Running',
  done: 'Done',
  partial: 'Partially done',
  failed: 'Failed',
  skipped: 'Skipped',
}

export const restoreStatusVariants = {
  pending: 'secondary',
  running: 'info',
  done: 'success',
  partial: 'warning',
  failed: 'danger',
  skipped: 'secondary',
}

export const ACTIVE_RESTORE_STATUSES = ['pending', 'running']

export const sourceLabels = {
  local: 'Local',
  remote: 'Remote',
}

export const formatDateTime = value => (value ? formatDate(value, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
}) : '-')
